import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContactTypes} from "../contact-dropdown-button/contact-dropdown-button.component";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgTemplateOutlet } from '@angular/common';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { InputValidatorsComponent } from '../../components/node-delegator/nodes/templates/input-validators/input-validators.component';
import { MatOption } from '@angular/material/select';
import { ActiveFormDirective } from '../../../../shared/directives/active-form/active-form.directive';
import { CountrySelectComponent } from '../../components/node-delegator/nodes/templates/country-select/country-select.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';

export interface DeleteContact {
    index: number,
    contactType: ContactTypes
}

@Component({
    selector: 'contacts-template',
    templateUrl: './contacts-template.component.html',
    styleUrls: ['./contacts-template.component.scss'],
    imports: [ReactiveFormsModule, NgTemplateOutlet, MatExpansionPanel, MatExpansionPanelHeader, MatAutocompleteTrigger, InputValidatorsComponent, MatAutocomplete, MatOption, ActiveFormDirective, CountrySelectComponent, MatSlideToggle]
})
export class ContactsTemplateComponent implements OnInit {

    @Input() contactInfo: UntypedFormGroup;
    @Output() delete: EventEmitter<DeleteContact> = new EventEmitter();

    readonly ContactTypes = ContactTypes;
    readonly emailTypes = ['Home', 'Work'];
    readonly phoneTypes = ['Mobile', 'Home', 'Work', 'Main'];
    readonly urlTypes = ['Home Page', 'Home', 'Work'];
    readonly addressFilteredOptions = ['Home', 'Work'];

    get addresses() {
        return (this.contactInfo.get('addresses') as UntypedFormArray).controls as UntypedFormControl[];
    }

    get emails() {
        return (this.contactInfo.get('emails') as UntypedFormArray).controls as UntypedFormControl[];
    }

    get organisations() {
        return (this.contactInfo.get('org') as UntypedFormArray).controls as UntypedFormControl[];
    }

    get phones() {
        return (this.contactInfo.get('phones') as UntypedFormArray).controls as UntypedFormControl[];
    }

    get urls() {
        return (this.contactInfo.get('urls') as UntypedFormArray).controls as UntypedFormControl[];
    }

    get birthdays() {
        return (this.contactInfo.get('birthdays') as UntypedFormArray).controls as UntypedFormControl[];
    }

    constructor() {
    }

    ngOnInit(): void {
    }

    deleteTemplate(index: number, contactType: ContactTypes) {
        const cont = this.contactInfo.get(contactType) as UntypedFormArray;
        cont.removeAt(index);
        this.delete.emit({
            index,
            contactType
        })
    }

}
